import { useState } from "react";

export type AccordionState = {
  [key: string]: boolean;
};

export function useAccordion(state: AccordionState) {
  const [accordionState, setAccordionState] = useState<AccordionState>(state);

  const handleAccordionClick = (key: string, forceTrue = false) => {
    setAccordionState((oldState) => {
      return {
        ...oldState,
        [key]: forceTrue ? forceTrue : !oldState[key],
      };
    });
  };

  return [accordionState, handleAccordionClick] as const;
}
